import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { EmailBuilderPage } from './emailBuilder';
import { InMailDetail, InMails } from './pages';

export const InMailsEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'InMails',
      element: <InMails />,
      path: '/',
    },
    {
      /* „Nowa wiadomość" zaczyna się od wyboru szablonu: dalej idzie kreator, a wysyłkę
         odpala się z jego paska. Stary formularz z polem treści zastąpił kreator. */
      label: 'Nowa wiadomość',
      element: <EmailBuilderPage />,
      path: '/new',
    },
    {
      label: 'Detail',
      element: <InMailDetail />,
      path: '/:id',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
